export enum codeStateEnum {
  CODE_ACV = "CODE_ACV",
  CODE_INVALIDE = "CODE_INVALIDE",
  CODE_MANQUANT = "CODE_MANQUANT",
}
